<template>
   <div :class="classModal+ ' smodal'">
			<div class="modal-background"></div>
  			<div class="modal-card">
	    		<header class="modal-card-head" >
				      <p class="modal-card-title" style="width:90%" >
                           <s-l id="filter_title_categorie">Filtrer par vos champs configurés :</s-l>
                        </p>	
				      <div style="float:rigth">
				      	<s-button theme="" label="" icon="times-circle" @onclick="$emit('close')"/>
				      </div>

				</header>
                <section class="modal-card-body">
                    
                    <div >
                            <div  v-for="(filter, indexFilter) in filtersLocal">
                                <filter-item :value="filter" :disabled="false"/>
                            </div>
                    </div>
                    <br/><br/>
                    <label class="title is-5">
                            <s-l id="filtertitle_joueurLicence">Filtrer par les joueurs licenciés :<br/>
                            <i style="font-size:14px">(si le numéro de licence est renseigné)</i></s-l>
                    </label><br/>
                    <label class="radio">
                        <input type="radio" name="isLicencie" v-model="filterByLicencie" :value="false"/> Non
                    </label>
                        &nbsp;
                    <label class="radio">
                        <input type="radio" name="isLicencie" v-model="filterByLicencie" :value="true"/> Oui
                    </label>
                <div style="float: right" v-show="filterByLicencie!=null">
                                <s-button @onclick="filterByLicencie=null" 
                                    theme="is-warning is-small" 
                                    label="Désactiver ce critère"
                                    icon="trash"
                                />
                    </div>
                    <div  v-show="inscritOnOff">
                        <label class="title is-5">
                            <s-l id="filter_title_inscritounon">Joueurs inscrits ou non</s-l>
                        </label>
                        <br/>
                        <label class="radio" >
                        <input type="radio" v-model="filterInscrit"  :value="null"   />
                                &nbsp;&nbsp;&nbsp;<span style="font-size:17px">Tous</span>
                    </label>
                    <label class="radio" >
                        <input type="radio" v-model="filterInscrit"  :value="true"   />
                                &nbsp;&nbsp;&nbsp;<span style="font-size:17px">Inscrit</span>
                    </label>
                        <label class="radio" >
                    <input type="radio" v-model="filterInscrit"  :value="false"   />
                                &nbsp;&nbsp;&nbsp;<span style="font-size:17px">Non Inscrit</span>
                        </label>
                    </div>
        	</section>
            <footer class="modal-card-foot">
                <div style="width:100%">
                <div style="float:right">
                    <s-button theme="is-success" icon="check" @onclick="apply()" label="Appliquer" />
                </div>
                <div style="float:left">
                    <s-button theme="is-warning" icon="undo" @onclick="$emit('cancel')" label="Annuler" />
                </div>
                </div>
            </footer>
         </div>
   </div>
</template>
<script>
    import filterItem     from '@/views/joueurs/filterItem.vue'
	export default  {
        props: ["open", "filters","inscritOnOff"],
        components: {
            filterItem
        },
        computed: {
            allfilters: {
                get() {
                    var filterReturn =  {
                        filtersCustoms: this.filtersLocal,
                        filterInscrit: this.filterInscrit,
                        filterByLicencie: this.filterByLicencie
                    }
                    return filterReturn;
                }
            }
        },
		data() {
			return {
                classModal: "modal",
                filtersLocal: [],
                filterInscrit: null,
                filterByLicencie: null
			}
        },
		watch: {
			open: function(val) {
               
				if (val) {
                    this.classModal = "modal is-active";
                    this.filtersLocal = JSON.parse(JSON.stringify(this.filters));
                }
				else
					this.classModal = "modal";
			}
        },
        methods: { 
            apply() {
                this.$emit('apply', this.allfilters)
            }
        }
	}
</script>